import { render, staticRenderFns } from "./EditPrivacyAndPolicy.vue?vue&type=template&id=6cb74e13&scoped=true&"
import script from "./EditPrivacyAndPolicy.vue?vue&type=script&lang=js&"
export * from "./EditPrivacyAndPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb74e13",
  null
  
)

export default component.exports